/**
 * Coups de pouce — Attendu 1039 « Mobiliser les critères de divisibilité
 * par 2, 5 et 10 » (automatisme 5e).
 *
 * Deux fiches (arbitrage prof 2026-08-30) :
 *   - critères : decisions_vf, reperer_qcm, reperer_qcm_neg, logique_vf ;
 *   - multiple : encadrement_saisie (définition du multiple, droite graduée).
 * Les valeurs des exemples (nombres à deux chiffres) sont hors des plages du
 * générateur (100 à 9 999) : l'aide ne peut jamais servir la réponse.
 */

const SVG_MULTIPLES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 110" role="img"
     aria-label="Droite graduée de 60 à 75. Les multiples de 10, c'est-à-dire 60 et 70, sont marqués par des points. La zone entre 62 et 71 est surlignée : elle ne contient qu'un seul multiple de 10, le nombre 70.">
  <rect x="62.7" y="50" width="192" height="38" fill="#fde68a" opacity="0.55" rx="4"/>
  <text x="62.7" y="44" font-size="11" fill="#b45309" text-anchor="middle" font-weight="bold">62</text>
  <text x="254.7" y="44" font-size="11" fill="#b45309" text-anchor="middle" font-weight="bold">71</text>
  <line x1="20" y1="70" x2="345" y2="70" stroke="#334155" stroke-width="2"/>
  <polygon points="345,70 337,66 337,74" fill="#334155"/>
  <line x1="20" y1="63" x2="20" y2="77" stroke="#334155" stroke-width="2"/>
  <line x1="126.7" y1="64" x2="126.7" y2="76" stroke="#334155" stroke-width="2"/>
  <line x1="233.3" y1="63" x2="233.3" y2="77" stroke="#334155" stroke-width="2"/>
  <line x1="340" y1="64" x2="340" y2="76" stroke="#334155" stroke-width="1.5"/>
  <line x1="41.3" y1="66" x2="41.3" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="62.7" y1="66" x2="62.7" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="84" y1="66" x2="84" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="105.3" y1="66" x2="105.3" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="148" y1="66" x2="148" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="169.3" y1="66" x2="169.3" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="190.7" y1="66" x2="190.7" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="212" y1="66" x2="212" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="254.7" y1="66" x2="254.7" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="276" y1="66" x2="276" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="297.3" y1="66" x2="297.3" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <line x1="318.7" y1="66" x2="318.7" y2="74" stroke="#94a3b8" stroke-width="1"/>
  <circle cx="20" cy="70" r="5" fill="#10b981"/>
  <circle cx="233.3" cy="70" r="5" fill="#10b981"/>
  <circle cx="233.3" cy="70" r="9" fill="none" stroke="#10b981" stroke-width="2"/>
  <text x="20" y="95" font-size="12" fill="#334155" text-anchor="middle" font-weight="bold">60</text>
  <text x="126.7" y="95" font-size="12" fill="#334155" text-anchor="middle">65</text>
  <text x="233.3" y="95" font-size="12" fill="#047857" text-anchor="middle" font-weight="bold">70</text>
  <text x="340" y="95" font-size="12" fill="#334155" text-anchor="middle">75</text>
</svg>`.trim();

const FICHE_CRITERES = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                '**Divisible par 2** : le nombre se termine par 0, 2, 4, 6 ou 8.',
                '**Divisible par 5** : le nombre se termine par 0 ou 5.',
                '**Divisible par 10** : le nombre se termine par 0.',
                'Seul le **dernier chiffre** décide : inutile de poser une division.',
            ],
        },
        {
            titre: 'Un exemple',
            lignes: [
                '74 se termine par **4** : divisible par 2.',
                '85 se termine par **5** : divisible par 5.',
                '90 se termine par **0** : divisible par 2, par 5 **et** par 10.',
            ],
        },
    ],
};

const CP_1039 = {
    decisions_vf: FICHE_CRITERES,
    reperer_qcm: FICHE_CRITERES,
    reperer_qcm_neg: FICHE_CRITERES,
    logique_vf: FICHE_CRITERES,
    encadrement_saisie: {
        pages: [
            {
                titre: 'La règle',
                lignes: [
                    '**Multiple de 10** : un résultat de la table de 10 : 10, 20, 30…',
                    'Un multiple de 10 se termine toujours par **0**.',
                    'Un multiple de 5 se termine par **0 ou 5**.',
                ],
            },
            {
                titre: 'Un exemple',
                lignes: [
                    'On cherche le **multiple de 10** entre 62 et 71 : un seul nombre dans cet intervalle se termine par 0, c\'est **70**.',
                ],
                svg: SVG_MULTIPLES,
            },
        ],
    },
};

export default CP_1039;
